import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { ApolloClient, InMemoryCache, ApolloProvider, HttpLink, split } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';
import { ActionCableLink } from './lib/actionCableLink';
import { cable } from './lib/cable';
import './index.css'
import App from './App.tsx'
import './i18n'
import { initAnalytics } from './utils/analytics'
import { initSentry } from './lib/sentry'

initSentry();
initAnalytics();

window.addEventListener('vite:preloadError', (event) => {
  const lastReload = Number(sessionStorage.getItem('chunkReloadAt'));
  if (Date.now() - lastReload < 10_000) return;
  event.preventDefault();
  sessionStorage.setItem('chunkReloadAt', String(Date.now()));
  window.location.reload();
});

const httpLink = new HttpLink({
  uri: '/graphql',
  credentials: 'include',
});

const wsLink = new ActionCableLink({ cable });

const link = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
  },
  wsLink,
  httpLink,
);

const client = new ApolloClient({
  link,
  cache: new InMemoryCache(),
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ApolloProvider client={client}>
      <Suspense fallback={<div>Loading...</div>}>
        <App />
      </Suspense>
    </ApolloProvider>
  </StrictMode>,
)
